// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_t-f1J clearfix","comment":"index_comment_ywL8c","pic":"index_pic_oOktC","v_logo":"index_v_logo_B1p2Q","text":"index_text_WRPmV","time":"index_time_pFl0l"};